import Vue from 'vue';

const success = (response, context) => {
  context.closeModal('#generate-analyses-results-modal');
  context.smallLoading = false;
  toastr.success(response.data.msg);
  context.analyseData = {
    'address': '',
    'rooms' : '',
    'email': context.account.email
  };
  $('.pac-target-input').val('');
};

const failed = (error, context) => {
  context.smallLoading = false;
  context.showToasterError(error);
};

export default (data, context) => {
  return Vue.$http.post('get-analyse-results', data)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/analytics/getAnalyseResults.js